import dayjs from 'dayjs';

const notifyWithinDays = Number(process.env.MIX_PROPERTY_DATES_WARNING_DAYS);

const getters = {
    // EPC
    hasEPCDate: (state) => {
        return Boolean(state.property.EPCExpiryDate);
    },
    parsedEPCExpiryDate: (state) => {
        return dayjs(state.property.EPCExpiryDate);
    },
    isEPCPreExpiring: (state, getters) => {
        const diff = getters.parsedEPCExpiryDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // PAT
    hasPATDate: (state) => {
        return Boolean(state.property.PATExpiryDate);
    },
    parsedPATExpiryDate: (state) => {
        return dayjs(state.property.PATExpiryDate);
    },
    isPATPreExpiring: (state, getters) => {
        const diff = getters.parsedPATExpiryDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Gas
    hasGasDate: (state) => {
        return Boolean(state.property.blnGas && state.property.GasExpiryDate);
    },
    parsedGasExpiryDate: (state) => {
        return dayjs(state.property.GasExpiryDate);
    },
    isGasPreExpiring: (state, getters) => {
        const diff = getters.parsedGasExpiryDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Electric
    hasElectricDate: (state) => {
        return Boolean(state.property.ElectricExpiryDate);
    },
    parsedElectricExpiryDate: (state) => {
        return dayjs(state.property.ElectricExpiryDate);
    },
    isElectricPreExpiring: (state, getters) => {
        const diff = getters.parsedElectricExpiryDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // HMO
    hasHMODate: (state) => {
        return Boolean(state.property.HMOExpiryDate);
    },
    parsedHMOExpiryDate: (state) => {
        return dayjs(state.property.HMOExpiryDate);
    },
    isHMOPreExpiring: (state, getters) => {
        const diff = getters.parsedHMOExpiryDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Inspection date
    hasInspectionDate: (state) => {
        return Boolean(state.property.NextInspectionVisit);
    },
    parsedInspectionDate: (state) => {
        return dayjs(state.property.NextInspectionVisit);
    },
    isInspectionPreExpiring: (state, getters) => {
        const diff = getters.parsedInspectionDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Legionella
    hasLegionellaDate: (state) => {
        return Boolean(state.property.LegionellaDate);
    },
    parsedLegionellaDate: (state) => {
        return dayjs(state.property.LegionellaDate);
    },
    isLegionellaPreExpiring: (state, getters) => {
        const diff = getters.parsedLegionellaDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Licence
    hasLicenceDate: (state) => {
        return Boolean(state.property.LicenceDate);
    },
    parsedLicenceDate: (state) => {
        return dayjs(state.property.LicenceDate);
    },
    isLicencePreExpiring: (state, getters) => {
        const diff = getters.parsedLicenceDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Detector
    hasDetectorDate: (state) => {
        return Boolean(state.property.DetectorDate);
    },
    parsedDetectorDate: (state) => {
        return dayjs(state.property.DetectorDate);
    },
    isDetectorPreExpiring: (state, getters) => {
        const diff = getters.parsedDetectorDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Boiler Service
    hasBoilerServiceDate: (state) => {
        return Boolean(state.property.BoilerServiceDate);
    },
    parsedBoilerServiceDate: (state) => {
        return dayjs(state.property.BoilerServiceDate);
    },
    isBoilerServicePreExpiring: (state, getters) => {
        const diff = getters.parsedBoilerServiceDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Oil Service
    hasOilServiceDate: (state) => {
        return Boolean(state.property.OilServiceDate);
    },
    parsedOilServiceDate: (state) => {
        return dayjs(state.property.OilServiceDate);
    },
    isOilServicePreExpiring: (state, getters) => {
        const diff = getters.parsedOilServiceDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },

    // Capped Gas
    hasCappedGasDate: (state) => {
        return Boolean(state.property.dteCappedGas);
    },
    parsedCappedGasDate: (state) => {
        return dayjs(state.property.dteCappedGas);
    },
    isCappedGasPreExpiring: (state, getters) => {
        const diff = getters.parsedCappedGasDate.diff(dayjs(), 'day');
        return (diff > notifyWithinDays);
    },
};

export default getters;
